module.exports = __webpack_public_path__ + "img/logo-dark.cad1b7df.svg";